<!-- Loading Screen -->

@if (isReportSending) {
  <div class="wrapper center"
    >
    <div class="inner">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- Start Fishing Report-->

@if (!isReportSending) {
  <div class="container report-container">
    <div class="container"
      style="padding-top: 20px;">
      <div class="row"
        align="center">
        @if (currPage <= numPages) {
          <h6 i18n>
        <small class="text-muted">
          Page {{currPage}} of {{numPages}}
        </small>
      </h6>
        }
        @if (currPage > numPages) {
          <h6 i18n>
        <small class="text-muted">
          Start Fishing Report
        </small>
      </h6>
        }
      </div>
      <div class="row"
        align="center">
        <div class="col-5"></div>
        <div class="col-2">
          @if (currPage <= numPages) {
            <mat-spinner
              mode="determinate"
              [diameter]="50"
              [strokeWidth]="6"
            [value]="spinnerProgress"></mat-spinner>
          }
          @if (currPage > numPages && !isComplete) {
            <mat-icon
              style="color: #3ebfb9">
              check_circle_outline
            </mat-icon>
          }
        </div>
        <div class="col-5"></div>
      </div>
    </div>
    <form [formGroup]="startForm">
      <!-- Choose Logbook -->
      @if (currPage === 1) {
        <div
          class="container details">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          Who is fishing?
        </h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          Vessel Master
        </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>Vessel Master</mat-label>
              <mat-select formControlName="fin" (selectionChange)="onFinChange($event)">
                @for (option of finOptions; track option) {
                  <mat-option [value]="option.fin">
                    {{ option.name }} (FIN: {{ option.fin }})
                  </mat-option>
                }
                <mat-option [value]="ADD_NEW_FISHER">
                  Add new vessel master...
                </mat-option>
              </mat-select>
            </mat-form-field>
            @if (startForm.get('fin')?.hasError('required')) {
              <mat-error i18n>
          Required
        </mat-error>
            }
            <!-- Disclaimer text -->
            <div class="vessel-master-disclaimer" style="margin: 1em 0; padding: .5em; border: 1px solid #ccc; border-radius: 4px;">
              <p>
                By selecting the I AGREE box you are acknowledging that you will be the Vessel Master of record for this trip as defined in the conditions of licence. The Vessel Master of record is responsible for all data pertaining to this trip recorded in the elog and submitted to DFO.
              </p>
              <p>
                If your name is not selected, make the correct Vessel Master selection in the above dropdown. If your name is not listed as an option for Vessel Master, please select "Add new vessel master" in the dropdown.
              </p>
              <p>
                If you are unable to complete this trip as Vessel Master, you must submit an END trip report, and the new Vessel Master must submit a START trip.
              </p>
              <p>
                To obtain licence clearance please ensure an END trip is submitted for the last trip of the season.
              </p>
              <p>
                If the licence will not be fished this season (gear will not be deployed into the water) submit a NIL fishing report.
              </p>
              <mat-checkbox
                formControlName="vesselMasterAgreement">
                I AGREE
              </mat-checkbox>
              @if (startForm.get('vesselMasterAgreement')?.hasError('required')) {
                <mat-error>
                  <small>You must agree before continuing.</small>
                </mat-error>
              }
            </div>
          </div>
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          What logbook are you using?
        </h5>
          </div>
          <div class="row">
            <h5 i18n class="blue-heading-subtitle">
          My available logbooks:
        </h5>
          </div>
          <div class="row">
            <div class="col-1"></div>
            <div class="col-10">
              <mat-radio-group class="radio"
                formControlName="logbook">
                @for (logbook of logbooks; track logbook) {
                  @if (logbook.isRegistered && (logbook.isActive)) {
                    <mat-radio-button
                      [value]="logbook"
                      [checked]="logbook.isChecked">
                      <h6 i18n>
                  <small class="text-muted font-list">
                    {logbook.gearName, select, Gill Net {Gillnet} Seine {Seine} Troll {Troll}} (#{{logbook.logbookID}})
                  </small>
                </h6>
                    </mat-radio-button>
                  }
                }
              </mat-radio-group>
            </div>
            <div class="col-1"></div>
          </div>
          <div class="row">
            <h5 i18n class="blue-heading-subtitle">
          Associated Vessel:
        </h5>
          </div>
          <div class="row">
            <div class="col-1"></div>
            <div class="col-10">
              <h6>
                <small class="text-muted font-list" style="display: block; padding-left: 15px; padding-top: 10px;">
                  {{startForm.get('logbook')?.value.vessel}}
                </small>
              </h6>
            </div>
            <div class="col-1"></div>
          </div>
        </div>
      }
      <!-- Choose license area -->
      @if (currPage === 2) {
        <div
          class="container details">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          What is your License Area?
        </h5>
          </div>
          <div class="row" style="padding-top: 20px;">
            <div class="col-1"></div>
            <div class="col-10">
              <mat-radio-group class="radio"
                formControlName="licenseArea">
                @for (area of licenseAreas; track area) {
                  <mat-radio-button
                    [value]="area"
                    [checked]="area.isChecked"
                    [class]="determineAreaClass(area)">
                    @if (area.gearType === startForm.get('logbook')?.value.gearName) {
                      <h6 i18n>
                <small class="text-muted font-list">
                  {area, select, A (Seine North) {A (Seine North)} B (Seine South) {B (Seine South)} C (Gillnet North) {C (Gillnet North)} D (Gillnet Vancouver Island) {D (Gillnet Vancouver Island)} E (Gillnet Fraser + VI) {E (Gillnet Fraser + VI)} F (Troll North) {F (Troll North)} G (Troll WCVI) {G (Troll WCVI)} H (Troll Fraser) {H (Troll Fraser)}}
                </small>
              </h6>
                    }
                  </mat-radio-button>
                }
              </mat-radio-group>
            </div>
            <div class="col-1"></div>
          </div>
          <div class="row"
            align="center"
            style="padding-top: 15px;">
            <h5 i18n class="blue-heading-title">
          Where do you intend to fish?
        </h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          Management Area
        </h6>
            <mat-form-field appearance="outline">
              <mat-label i18n>
            Management Area
          </mat-label>
              <mat-select formControlName="managementArea" [compareWith]="compareArea">
                @for (area of managementAreas; track area) {
                  <mat-option i18n
                    [value]="area">
              {area, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}
            </mat-option>
                }
              </mat-select>
              @if (startForm.invalid) {
                <mat-error i18n>
            Required
          </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }
      <!-- Choose date and enter area to start fishing -->
      @if (currPage === 3) {
        <div
          class="container details">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          When do you intend to start fishing?
        </h5>
          </div>
          <div class="row"
            align="center">
            <div class="col-2"></div>
            <div class="col-8">
              <mat-card class="demo-inline-calendar-card calendar-width" style="margin-top: 10%">
                <mat-calendar [(selected)]="startDate"></mat-calendar>
              </mat-card>
              <div class="outer">
                <div class="inner-2">
                  <h6 i18n class="blue-label">
                Start Time (24 Hr): &nbsp;
              </h6>
                </div>
                <div class="inner-2">
                  <ngb-timepicker class="time-picker" [spinners]="false"
                  formControlName="startTime"></ngb-timepicker>
                  @if (startForm.get('startTime')?.hasError('withinSixHours')) {
                    <mat-error i18n
                      style="margin-left: 15px;">
                Start time must be within 6 hours of now
              </mat-error>
                  }
                </div>
                <div class="inner-2">
                  <button mat-mini-fab matTooltip="Fill with current time" style="margin-left: 15px; background-color: #3ebfb9;" (click)="fillCurrentTime()">
                    <mat-icon>schedule</mat-icon>
                  </button>
                </div>
              </div>
              <div class="col-2"></div>
            </div>
          </div>
        </div>
      }
      <!-- Comments -->
      @if (currPage === 4) {
        <div
          class="container">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          Would you like to add a comment?
        </h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          Comments
        </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>
            Comments...
          </mat-label>
              <textarea matInput
                maxlength="300"
                rows="9"
              formControlName="comments"></textarea>
            </mat-form-field>
          </div>
        </div>
      }
      <!-- Summary page -->
      @if (currPage > numPages) {
        <div
          class="container details">
          @if (!isComplete) {
            <div class="row"
              align="center">
              <h5 i18n class="blue-heading-title">
          Is all Hail Out information complete and ready to be submitted to DFO?
        </h5>
            </div>
          }
          @if (isComplete) {
            <div class="row">
              <h6 class="blue-label">
                <b i18n>
            Confirmation Number:
          </b>
                @if (startReport.confirmationNumber === 'Incomplete' ||
                  startReport.confirmationNumber === 'Not submitted' ||
                  startReport.confirmationNumber === 'Awaiting response') {
                  <span i18n>
            {this.startReport.confirmationNumber, select, Incomplete {Incomplete} Not submitted {Not submitted} Awaiting response {Awaiting response}}
          </span>
                } @else {
                  {{this.startReport.confirmationNumber}}
                }
              </h6>
            </div>
          }
          @if (this.startReport.confirmationNumber == 'Not submitted') {
            <div>
              <span i18n class="blue-label">
          Go to the records page to submit outstanding reports
        </span>
            </div>
          }
          @if (reportFailed) {
            <div class="row">
              <button mat-raised-button
                class="fishing-button-red"
                type="submit"
                (click)="reopenReport()"
                style="width: auto; text-align: left;">
                <span i18n>
            Reopen report
          </span>
              </button>
            </div>
          }
          <div class="row">
            <h6 class="blue-label">
              <b i18n>Vessel Master:</b>
              <span>
                {{ selectedFinOption?.name }} (FIN: {{ selectedFinOption?.fin }})
              </span>
              @if (startForm.get('fin')?.hasError('required')) {
                <span
                  class="invalid-field">
                  Required
                </span>
              }
            </h6>
          </div>
          <div class="row">
            <h6 class="blue-label">
              <b i18n>
            Logbook:
          </b>
              @if (logbookValid) {
                <span i18n>
            {selectedLogbook.gearName, select, Gill Net {Gillnet} Seine {Seine} Troll {Troll}} (#{{selectedLogbook.logbookID}})
          </span>
              }
              @if (!logbookValid) {
                <span i18n
                  class="invalid-field">
            [Required]
          </span>
              }
            </h6>
          </div>
          <div class="row">
            <h6 class="blue-label">
              <b i18n>
            Vessel:
          </b>
              @if (vesselValid) {
                <span i18n>
            {{selectedVessel}}
          </span>
              }
              @if (!vesselValid) {
                <span i18n
                  class="invalid-field">
            [Required]
          </span>
              }
            </h6>
          </div>
          <div class="row">
            <h6 class="blue-label">
              <b i18n>
            License Area:
          </b>
              @if (licenseAreaValid) {
                <span i18n>
            {selectedLicenseArea, select, A (Seine North) {A (Seine North)} B (Seine South) {B (Seine South)} C (Gillnet North) {C (Gillnet North)} D (Gillnet Vancouver Island) {D (Gillnet Vancouver Island)} E (Gillnet Fraser + VI) {E (Gillnet Fraser + VI)} F (Troll North) {F (Troll North)} G (Troll WCVI) {G (Troll WCVI)} H (Troll Fraser) {H (Troll Fraser)}}
          </span>
              }
              @if (!licenseAreaValid) {
                <span i18n
                  class="invalid-field">
            [Required]
          </span>
              }
            </h6>
          </div>
          <div class="row">
            <h6 class="blue-label">
              <b i18n>
            Management Area:
          </b>
              @if (mgmtAreaValid) {
                <span i18n>
            {startForm.get('managementArea')?.value, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}

          </span>
              }
              @if (!mgmtAreaValid) {
                <span i18n
                  class="invalid-field">
            [Required]
          </span>
              }
            </h6>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          <b>
            Start Date:
          </b>
          {{ startDate | date }}
        </h6>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          <b>
            Start Time:
          </b>
          @if (startTimeValid) {
<span>
            {{ startDate | date:'h:mm a' }}
          </span>
}
          @if (startForm.get('startTime')?.hasError('withinSixHours')) {
<span
                class="invalid-field">
            [Start time must be within 6 hours of now]
          </span>
}
          @if (startForm.get('startTime')?.hasError('required')) {
<span
                class="invalid-field">
            Required
          </span>
}
        </h6>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          <b>Comments:</b>
          <span>
            {{startForm.get('comments')?.value}}
          </span>
        </h6>
          </div>
        </div>
      }
    </form>
    <!-- Page navigation buttons -->
    @if (!isComplete) {
      <div  class="row bottom-buttons">
        <div class="col-1"></div>
        <div class="col-4">
          <div class="row">
            <button mat-raised-button
              class="fishing-button-blue"
              type="button"
              (click)="toPreviousPage()">
              <span i18n>
            Back
          </span>
            </button>
          </div>
        </div>
        <div class="col-2"></div>
        <div class="col-4">
          <div class="row">
            <button mat-raised-button
              class="fishing-button-red"
              type="submit"
              (click)="toNextPage()">
              @if (currPage <= numPages) {
                <span i18n>
            Next
          </span>
              }
              @if (currPage > numPages) {
                <span i18n>
            Submit
          </span>
              }
            </button>
          </div>
        </div>
        <div class="col-1"></div>
      </div>
    }
    @if (isComplete) {
      <div class="row bottom-buttons" style="display: flex; justify-content: center;">
        <div class="col-4">
          <div class="row" style="display: flex; justify-content: center;">
            <button mat-raised-button
              class="fishing-button-blue"
              type="button"
              (click)="toPreviousPage()">
              <span i18n>
            Back
          </span>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}
